module.exports = __webpack_public_path__ + "img/webrebalance-19.71e1dd63.svg";